import React, { useState, useEffect } from 'react';
import { CountUp } from 'use-count-up';
import { stats } from '../data/mock';

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('stats');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <section id="stats" className="relative bg-black py-20 overflow-hidden">
      {/* Animated Background Grid */}
      <div className="absolute inset-0 futuristic-grid opacity-30" />
      <div className="absolute inset-0 scanlines" />
      
      {/* Holographic Lines */}
      <div className="absolute top-0 left-0 right-0 h-[2px] holographic" />
      <div className="absolute bottom-0 left-0 right-0 h-[2px] holographic" />

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            // Extract number from stat.number (e.g., "150+" -> 150)
            const numericValue = parseInt(stat.number.replace(/\D/g, ''));
            const suffix = stat.number.replace(/[0-9]/g, '');

            return (
              <div 
                key={index}
                className="text-center group transform-3d"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 150}ms both`
                }}
              >
                <div className="relative glass-card p-6 rounded-2xl hover-lift group-hover:neon-red transition-all duration-500">
                  {/* Rotating Border Effect */}
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute inset-0 rounded-2xl border-2 border-red-600 animate-spin-slow" />
                  </div>

                  {/* Content */}
                  <div className="relative z-10">
                    <div className="text-4xl md:text-5xl lg:text-6xl font-bold mb-2 text-white text-3d">
                      {isVisible ? (
                        <CountUp isCounting end={numericValue} duration={2} />
                      ) : (
                        '0'
                      )}
                      {suffix}
                    </div>
                    <div className="text-sm md:text-base text-white/70 uppercase tracking-widest font-medium">
                      {stat.label}
                    </div>
                  </div>

                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-t from-red-600/10 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
